module.exports = __webpack_public_path__ + "img/colombia.29fa048d.svg";